(() => {
  // scripts/sections/intro-banner.ts
  document.addEventListener("DOMContentLoaded", () => {
    const banner = document.querySelector("[data-intro-banner]");
    if (!banner) return;
    const mediaElements = banner.querySelectorAll("img, video");
    if (mediaElements.length === 0) {
      banner.classList.add("is-loaded");
      return;
    }
    let loadedCount = 0;
    const total = mediaElements.length;
    function checkLoaded() {
      loadedCount++;
      if (loadedCount === total) {
        banner == null ? void 0 : banner.classList.add("is-loaded");
      }
    }
    mediaElements.forEach((el) => {
      if (el.tagName === "IMG") {
        if (el.complete && el.naturalWidth !== 0) {
          checkLoaded();
        } else {
          el.addEventListener("load", checkLoaded, { once: true });
          el.addEventListener("error", checkLoaded, { once: true });
        }
      } else if (el.tagName === "VIDEO") {
        if (el.readyState >= 3) {
          checkLoaded();
        } else {
          el.addEventListener("loadeddata", checkLoaded, { once: true });
          el.addEventListener("error", checkLoaded, { once: true });
        }
      }
    });
  });
})();
